import { render, staticRenderFns } from "./yqg-indicator.vue?vue&type=template&id=6cfa0922&scoped=true&"
import script from "./yqg-indicator.vue?vue&type=script&lang=js&"
export * from "./yqg-indicator.vue?vue&type=script&lang=js&"
import style0 from "./yqg-indicator.vue?vue&type=style&index=0&id=6cfa0922&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa0922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfa0922')) {
      api.createRecord('6cfa0922', component.options)
    } else {
      api.reload('6cfa0922', component.options)
    }
    module.hot.accept("./yqg-indicator.vue?vue&type=template&id=6cfa0922&scoped=true&", function () {
      api.rerender('6cfa0922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/vue/component/yqg-indicator/yqg-indicator.vue"
export default component.exports